/**
 * The base name of the illustration files (not including theme or filetype).
 *
 * Store illustrations in internal/static/images/illustrations/
 * and then import them in internal/static/supplier/index.js
 *
 * Illustrations should be PNGs and have a light and dark prefix for
 * the corresponding modes.
 * For example:
 *
 * illustrations-chat-inbox-light.png
 * illustrations-chat-inbox-dark.png
 *
 * In the event that the same image is used for both light and dark mode,
 * copy the image and use the same naming conventions.
 *
 * When exporting from figma, use the 4x PNG export to make sure the
 * illustration appears sharp on all types of displays.
 */
const illustrationFiles = {
  // supplier
  inbox: 'illustrations-chat-inbox',
  chat: 'illustrations-chat-inbox',
  search: 'illustrations-search',
  cart: 'illustrations-cart',
  trophy: 'illustrations-trophy',
  emptyInvoices: 'illustrations-empty-invoices',
  emptyVenue: 'illustrations-empty-venue',
  emptyFavourites: 'illustrations-empty-favourites',
  emptyFavouritesBasket: 'illustrations-empty-favourites-basket',
  emptyUsers: 'illustrations-empty-users',
  emptyOrders: 'illustrations-empty-orders',
  emptyProperties: 'illustrations-empty-properties',
  emptyServiceAreas: 'illustrations-empty-service-areas',
  emptyBoxes: 'illustrations-empty-boxes',

  // dashboard / venue
  emptyNoVenue: 'illustrations-empty-no-venue',
  emptyRewardsEarn: 'illustrations-empty-rewards-earn',
  emptyInsights: 'illustrations-empty-insights',
};

export type IllustrationNames = keyof typeof illustrationFiles;

export type IllustrationFilesType = {
  [name in IllustrationNames]: string;
};

export default illustrationFiles as IllustrationFilesType;
